<div class="fixed top-1 right-1 -translate-x-1 translate-y-1 m-auto flex items-center justify-between p-3 px-4 rounded shadow-md bg-zinc-800 text-white min-w-[288px] max-w-[568px] z-[1000]" [ngClass]="data?.panelClass">
  <div>{{ data?.message }}</div>
  <button class="ml-6 uppercase bg-transparent text-white border-none cursor-pointer font-medium" (click)="close()">{{ data?.action }}</button>
</div>
